import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CircularProgress from "@material-ui/core/CircularProgress";
import "./readOnlyImpactView.css";
import {
  setReadOnlyImpactView,
  setSelectedMenuItem,
  setSelectedPrescription,
} from "actions/Management";

export const normalizeImpactPrescription = (prescription) => {
  if (!prescription) return null;

  const patient = prescription.patient ?? prescription.Patient ?? {};

  return {
    ...prescription,
    id: prescription.id ?? prescription.Id,
    stateId: prescription.stateId ?? prescription.StateId,
    impactId: prescription.impactId ?? prescription.ImpactId,
    productLineId: prescription.productLineId ?? prescription.ProductLineId,
    customProductBehaviorId:
      prescription.customProductBehaviorId ?? prescription.CustomProductBehaviorId,
    expeditionDate: prescription.expeditionDate ?? prescription.ExpeditionDate,
    code: prescription.code ?? prescription.Code,
    medicineAmount: prescription.medicineAmount ?? prescription.MedicineAmount,
    patient: {
      ...patient,
      id: patient.id ?? patient.Id,
      isOnlyTracing: patient.isOnlyTracing ?? patient.IsOnlyTracing ?? false,
    },
  };
};

const ImpactViewBridge = ({ prescription, folderType, children }) => {
  const dispatch = useDispatch();
  const { selectedPrescription, isReadOnlyImpactView } = useSelector(
    ({ management }) => management
  );
  const normalized = normalizeImpactPrescription(prescription);

  useEffect(() => {
    if (!normalized?.impactId) return;

    dispatch(setReadOnlyImpactView(true));
    dispatch(setSelectedMenuItem(folderType));
    dispatch(setSelectedPrescription(normalized));
    document.body.classList.add("read-only-impact-view-active");

    return () => {
      document.body.classList.remove("read-only-impact-view-active");
    };
  }, [dispatch, folderType, normalized?.id, normalized?.impactId]);

  const isReady =
    isReadOnlyImpactView &&
    normalized &&
    selectedPrescription &&
    selectedPrescription.id === normalized.id &&
    selectedPrescription.impactId === normalized.impactId;

  if (!isReady) {
    return (
      <div className="text-center p-4">
        <CircularProgress />
      </div>
    );
  }

  return (
    <fieldset
      disabled
      className="read-only-impact-view"
      style={{ border: 0, margin: 0, padding: 0, minWidth: 0 }}
    >
      {children}
    </fieldset>
  );
};

export default ImpactViewBridge;
